

















































import Vue from 'vue'
import ArcChart from '@/components/elements/accountBalanceDetails/ArcChart.vue'
import AccountBalanceDetailsCard from '@/components/elements/accountBalanceDetails/AccountBalanceDetailsCard.vue'
import AccountBalanceDetailsCardDesktop
  from '@/components/elements/accountBalanceDetails/AccountBalanceDetailsCardDesktop.vue'
import { ArcDataTab, DataTab } from '@/config/interfaces'
import Utils from '@/helpers/Utils'

export default Vue.extend({
  name: 'AccountBalanceDetailsChart',

  components: { ArcChart },

  methods: {
    createGraphData (dataTab: DataTab): Array<ArcDataTab> {
      return Utils.createGraphData(dataTab)
    }
  },

  computed: {
    getAppropriateCardDisplay () {
      if (this.isDesktop) {
        return AccountBalanceDetailsCardDesktop
      }
      return AccountBalanceDetailsCard
    }
  },

  props: {
    activeTab: {
      type: Object as () => DataTab,
      required: true
    }
  }
})
